import { Component } from 'preact';
import { Transition } from 'react-transition-group';
import velocity from '../../helpers/Velocity';

export default class SlideDownTransition extends Component {

	handleEnter(node) {
		velocity(node, 'slideDown', { duration: this.props.timeout, delay: this.props.delay, easing: 'ease-in' });
	}

	handleExit(node) {
		velocity(node, 'slideUp', { duration: this.props.timeout, delay: this.props.delay, easing: 'ease-in' });
	}

	constructor(props) {
		super(props);
		// Arrow notation binding did not work for some reason in this case
		this.handleEnter = this.handleEnter.bind(this);
		this.handleExit = this.handleExit.bind(this);
	}

	render(props, state, context) {
		return <Transition {...props} onEnter={this.handleEnter} onExit={this.handleExit} />;
	}
}



// WEBPACK FOOTER //
// ./components/transitions/SlideDownTransition.js